<script>
import Layout from '@layouts/default'
import { orderMethods, referralMethods } from '@state/helpers'
import _ from 'lodash'
// import liveChat from '@components/live-chat'
import formatDate from '@utils/format-date'

export default {
  page: {
    title: 'Checkout Confirmation',
    meta: [{ name: 'description', content: 'Checkout Confirmation' }],
  },
  components: { Layout },
  data() {
    return {
      checkoutComplete: false,
      checkoutResponse: null,
      product: _.get(this, '$store.state.customer.cart'),
      products: null,
      activeVinSearch: _.get(this, '$store.state.vhr.vehicle.vin'),
      currentUserData: _.get(this, '$store.state.auth.currentUser'),
    }
  },
  computed: {
    totalPrice() {
      if (this.checkoutResponse) {
        let fullPrice =
          parseFloat(this.product.price) +
          parseFloat(this.checkoutResponse.totalTax)

        return fullPrice.toFixed(2)
      } else {
        return ''
      }
    },
  },
  created: function() {
    this.saveOrderDetails()
    this.productImage = `../${this.product.image}`
    this.paypalImage = `../images/paypal-checkout.png`
  },
  methods: {
    ...orderMethods,
    ...referralMethods,
    setCheckoutCompletion() {
      // TODO: remove legacy code once Analytics 360 is dead
      this.$ga.set('dimension4', this.currentUserData.id.toString())
      this.$ga.set('dimension5', formatDate(new Date(), 'MM/DD/YYYY HH:mm:ss'))
      this.$ga.ecommerce.addTransaction({
        id: this.checkoutResponse.transactionId, // Transaction ID. Required.
        affiliation: 'autocheck.com', // Affiliation or store name.
        revenue: this.checkoutResponse.totalPrice.toFixed(2), // Grand Total.
        shipping: 0, // Shipping.
        tax: this.checkoutResponse.totalTax.toFixed(2), // Tax.
      })

      this.$ga.ecommerce.addItem({
        id: this.checkoutResponse.transactionId, // Transaction ID. Required.
        sku: this.product.code, // SKU/code.
        name: this.product.name,
        price: parseFloat(this.product.price),
        quantity: 1,
      })
      this.$ga.ecommerce.send()

      if (this.$gtag) {
        this.$gtag.event('capture_customer_id', {
          UniqueCustomerID: this.currentUserData.id.toString(),
          UniqueCustomerIDPurchaseTime: formatDate(
            new Date(),
            'MM/DD/YYYY HH:mm:ss'
          ),
        })

        // GA4 purchase
        const items = [
          {
            item_id: this.product.code,
            item_name: this.product.name,
            price: parseFloat(this.product.price),
            currency: 'USD',
            quantity: 1,
          },
        ]

        this.$gtag.purchase({
          transaction_id: this.checkoutResponse.transactionId,
          affiliation: 'autocheck.com',
          value: this.checkoutResponse.totalPrice.toFixed(2),
          shipping: 0,
          tax: this.checkoutResponse.totalTax.toFixed(2),
          items: items,
          currency: 'USD',
        })
      }
    },
    saveOrderDetails() {
      return this.checkoutPaypalSuccess()
        .then((response) => {
          this.checkoutComplete = true
          this.checkoutResponse = response
          this.setCheckoutCompletion()
          // Clear session storage and revert to siteID 0 after checkout completion
          // MS160AS comment below line out.  Business rules changed; so the
          // user will not switch to an organic user after puchase.
          // It will retrieve products for the current siteID
          // This is for ticket ACATB - 5177 - 11/15/2019
          // sessionStorage.clear()
          this.getData(this.siteID)
            .then((response) => {
              this.getProducts()
                .then((response) => {
                  this.products = response.map((product) => {
                    product.image = `../${product.image}`
                    return product
                  })
                })
                .catch((error) => {
                  this.productError = error
                })
            })
            .catch((error) => {
              this.productError = error
            })
        })
        .catch((error) => {
          this.tryingToCheckout = false
          this.checkoutError = error
        })
    },
    goToVehicleReport(vin) {
      this.$router.push({
        name: 'full-vehicle-report',
        params: { vin: vin },
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div v-if="checkoutComplete" class="row">
      <div class="col-12 mt-4">
        <h2>Welcome!</h2>
      </div>
      <div class="col-md-8 col-12 mt-4 mb-4">
        <div class="cardContainer">
          <div class="cardContent">
            <p
              >Thank you for choosing AutoCheck: Scroll down for your order
              confirmation.</p
            >
            <BaseLink v-if="!activeVinSearch" :to="{ name: 'dashboard' }">
              <BaseButton button-type="buttonPrimary">
                <span>Go to My Account</span>
              </BaseButton>
            </BaseLink>
            <BaseButton
              v-else
              button-type="buttonPrimary"
              @click="goToVehicleReport(activeVinSearch)"
            >
              <span>View Report</span>
            </BaseButton>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-4 mb-4">
        <!--<liveChat :is-link="false" />-->
      </div>
      <div class="col-md-8 col-12 mb-3">
        <h3
          >Thank you for choosing AutoCheck: Your order number is
          {{ checkoutResponse.transactionId }}</h3
        >
      </div>
      <div class="col-md-4 col-12 mb-3"> </div>
      <div class="col-md-8 col-12">
        <div class="cardContainer productPanel" :class="$style.product">
          <div class="row">
            <div class="col-md-4 col-12">
              <img :src="productImage" />
            </div>
            <div
              class="col-md-8 col-12 productDescription"
              :class="$style.productDesc"
            >
              <span>${{ product.price }}</span>
              <div v-html="product.htmlDescription"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4"> </div>
            <div class="col-md-8" :class="$style.paymentSummary">
              <ul>
                <li
                  ><div class="content-offer">Digital dashboard delivery</div
                  ><span>FREE</span></li
                >
                <li
                  ><div class="content-offer"
                    >Buyback Protection for qualified, registered vehicles</div
                  ><span>FREE</span></li
                >
                <li
                  ><div class="content-offer">Local sales tax</div
                  ><span>${{ checkoutResponse.totalTax.toFixed(2) }}</span></li
                >
                <li :class="$style.orderTotal"
                  ><div class="content-offer">Total</div>
                  <span>${{ totalPrice }}</span></li
                >
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <div class="cardContainer">
          <div class="cardContent">
            <h4>Payment Details</h4>
            <p
              >Thank you for your order. Because your security is important to
              us we will not save your credit card or PayPal information once
              you have completed your transaction.</p
            >
            <div :class="$style.payment">
              <p
                ><strong>PayPal Info</strong>
                <img
                  style="padding: 10px; width: 100px; margin-top: -5px;"
                  :src="paypalImage"
              /></p>
              <p
                >{{ checkoutResponse.paymentInfo.billingAddress.firstName }}
                {{ checkoutResponse.paymentInfo.billingAddress.lastName }}</p
              >
              <p>{{ checkoutResponse.paymentInfo.billingAddress.email }}</p>
              <p class="mt-3"><strong>PayPal Billing Address</strong></p>
              <p
                >{{
                  checkoutResponse.paymentInfo.billingAddress.streetName
                }},</p
              >
              <p
                >{{ checkoutResponse.paymentInfo.billingAddress.town }},
                {{ checkoutResponse.paymentInfo.billingAddress.region }},
                {{ checkoutResponse.paymentInfo.billingAddress.postalCode }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row mt-4">
      <div class="col-12">
        <b-alert v-if="checkoutError" variant="danger" show dismissible>
          There was an error processing this transaction
        </b-alert>
        <h1 v-else>Loading transaction details..</h1>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.payment {
  p {
    margin-bottom: 5px;
  }
  strong {
    margin-top: 10px;
  }
}
.paymentSummary {
  ul {
    padding-left: 0;
    list-style: none;
    li {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 3px 0;
    }
  }
}
.orderTotal {
  padding-top: 10px !important;
  font-size: 20px;
  font-weight: bold;
}
.productDesc {
  position: relative;
  > span {
    position: absolute;
    top: 30px;
    right: 15px;
    font-size: 20px;
  }
  @media (max-width: 768px) {
    > span {
      top: 30px;
      font-size: 20px !important;
    }
    h5 {
      font-size: 15px !important;
    }
  }
}
</style>
